import pino from 'pino'

export type Logger = ReturnType<typeof getLoggerService>

export function getLoggerService(params: { level: pino.LevelWithSilent }) {
  const { level } = params
  return pino({
    level,
    browser: {
      asObject: true,
      serialize: true,
      transmit: {
        level,
        send: (_level, _logEvent) => {
          // console.warn('TX', level, logEvent)
        }
      }
    }
  })
}
